"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("app");
const youtubeProvider_1 = require("./providers/youtubeProvider");
const youTubeWrapper_1 = require("./youTubeWrapper");
const react_1 = require("react");
const getEmbedUrl = ({ videoUrl, videoId, provider, cookieCategoriesAcceptance, embedUrl, }) => {
    if (videoUrl) {
        const isEmbedUrl = app_1.VideoService.checkIfEmbedUrl(videoUrl);
        if (isEmbedUrl) {
            return videoUrl;
        }
        const videoObj = app_1.VideoService.parseUrl(videoUrl);
        return app_1.VideoService.createEmbedUrl(videoObj, cookieCategoriesAcceptance);
    }
    if (embedUrl) {
        return embedUrl;
    }
    if (videoId && provider) {
        const videoObj = {
            provider,
            id: videoId,
        };
        return app_1.VideoService.createEmbedUrl(videoObj, cookieCategoriesAcceptance);
    }
    return null;
};
const VideoPlayer = props => {
    const iframeRef = (0, react_1.useRef)(null);
    const youtubeCookiesAllowed = (0, react_1.useMemo)(() => youtubeProvider_1.default.isConsentGivenForYoutubeCookies(props.cookieCategoriesAcceptance), [props.cookieCategoriesAcceptance]);
    const { youtubeId, isYoutubeVideo, embedUrl } = (0, react_1.useMemo)(() => {
        let videoProvider = null;
        let yId;
        if (props.videoId && props.provider) {
            yId = props.videoId;
            videoProvider = props.provider;
        }
        else if (props.videoUrl) {
            const videoObject = app_1.VideoService.parseUrl(props.videoUrl);
            yId = videoObject.id;
            videoProvider = videoObject.provider;
        }
        const isYT = videoProvider ? app_1.VideoService.checkIfYoutube(videoProvider) : false;
        let embUrl = null;
        if (!isYT || (isYT && !youtubeCookiesAllowed)) {
            embUrl = getEmbedUrl(props);
        }
        return { youtubeId: yId, isYoutubeVideo: isYT, embedUrl: embUrl };
    }, [
        props.videoUrl,
        props.videoId,
        props.provider,
        props.cookieCategoriesAcceptance,
        props.embedUrl,
        youtubeCookiesAllowed,
    ]);
    (0, react_1.useEffect)(() => {
        return () => {
            if (iframeRef.current) {
                iframeRef.current.src = '';
            }
        };
    }, []);
    const iframeClassName = 'w-full h-full';
    const iframe = isYoutubeVideo && youtubeCookiesAllowed ? ((0, jsx_runtime_1.jsx)(youTubeWrapper_1.default, { videoId: youtubeId, onVideoEvent: props.onVideoEvent, containerClassName: iframeClassName, playerVars: props.playerVars })) : (embedUrl && ((0, jsx_runtime_1.jsx)("iframe", Object.assign({ ref: iframeRef, tabIndex: 0, className: iframeClassName, src: embedUrl }, props.iframe))));
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: iframe }));
};
exports.default = VideoPlayer;
